<app-shared-dialog
  [title]="(isUpdate ? 'knowledge_base.external_references.dialog.title_edit' : 'knowledge_base.external_references.dialog.title_create') | translate"
  [options]="{
    cancelText: 'common.cancel' | translate,
    customConfirmButton: true
  }"
  (cancel)="close()"
>
  <form class="information-form" [formGroup]="form">
    <div class="form-content">
      <!-- Description -->
      <p class="add-external-reference__description">
        {{ "knowledge_base.external_references.dialog.description" | translate }}
      </p>

      <!-- Product (autocomplete, required) -->
      <div class="standard-input">
        <label>{{ "knowledge_base.external_references.dialog.product" | translate }}</label>
        <div class="autocomplete-wrapper">
          <input
            type="text"
            class="is-autocomplete"
            [disabled]="!(canSubmit$ | async)"
            [formControl]="productSearchControl"
            [matAutocomplete]="productAuto"
            [placeholder]="'knowledge_base.external_references.dialog.product_placeholder' | translate"
          />
          <button
            *ngIf="productSearchControl.value && (canSubmit$ | async)"
            type="button"
            class="autocomplete-clear"
            (click)="clearProduct(); $event.stopPropagation()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <mat-autocomplete #productAuto="matAutocomplete" [displayWith]="displayProductFn" (optionSelected)="onProductSelected($event.option.value)">
          <mat-option *ngIf="productSearchState === 'idle'" disabled>
            {{ "knowledge_base.external_references.dialog.start_typing" | translate }}
          </mat-option>
          <mat-option *ngFor="let product of filteredProducts$ | async" [value]="product">
            {{ product.label }}
          </mat-option>
          <mat-option *ngIf="productSearchState === 'results' && (filteredProducts$ | async)?.length === 0" disabled>
            {{ "knowledge_base.external_references.dialog.no_products" | translate }}
          </mat-option>
        </mat-autocomplete>
        <div class="error" *ngIf="form.get('sku')?.invalid && (form.get('sku')?.touched || form.get('sku')?.dirty)">
          <small *ngIf="form.get('sku')?.hasError('required')">{{ "validation.required" | translate }}</small>
        </div>
      </div>

      <!-- External reference (required text input) -->
      <div class="standard-input">
        <label>{{ "knowledge_base.external_references.dialog.external_reference" | translate }}</label>
        <ui-form-field
          type="text"
          formControlName="reference_code"
          [disabled]="!(canSubmit$ | async)"
          [placeholder]="'knowledge_base.external_references.dialog.external_reference_placeholder' | translate"
          [errorMessages]="{ required: ('validation.required' | translate) }"
        >
        </ui-form-field>
      </div>

      <!-- Customer (autocomplete, required — no optional label) -->
      <div class="standard-input">
        <label>{{ "knowledge_base.external_references.dialog.customer" | translate }}</label>
        <div class="autocomplete-wrapper">
          <input
            type="text"
            class="is-autocomplete"
            [disabled]="!(canSubmit$ | async)"
            [formControl]="customerSearchControl"
            [matAutocomplete]="customerAuto"
            [placeholder]="'knowledge_base.external_references.dialog.customer_placeholder' | translate"
          />
          <button
            *ngIf="customerSearchControl.value && (canSubmit$ | async)"
            type="button"
            class="autocomplete-clear"
            (click)="clearCustomer(); $event.stopPropagation()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <mat-autocomplete
          #customerAuto="matAutocomplete"
          [displayWith]="displayCustomerFn"
          (optionSelected)="onCustomerSelected($event.option.value)"
        >
          <mat-option *ngIf="customerSearchState === 'idle'" disabled>
            {{ "knowledge_base.external_references.dialog.start_typing" | translate }}
          </mat-option>
          <mat-option *ngFor="let customer of filteredCustomers$ | async" [value]="customer">
            {{ customer.label }}
          </mat-option>
          <mat-option *ngIf="customerSearchState === 'results' && (filteredCustomers$ | async)?.length === 0" disabled>
            {{ "knowledge_base.external_references.dialog.no_customers" | translate }}
          </mat-option>
        </mat-autocomplete>
        <div class="error" *ngIf="form.get('customer_id')?.invalid && (form.get('customer_id')?.touched || form.get('customer_id')?.dirty)">
          <small *ngIf="form.get('customer_id')?.hasError('required')">{{ "validation.required" | translate }}</small>
        </div>
      </div>
    </div>
  </form>
  <ui-button
    customConfirm
    *appHasPermission="submitPermission()"
    type="primary"
    [label]="(isUpdate ? 'common.update' : 'common.create') | translate"
    icon="arrow-right"
    iconPosition="end"
    (click)="save()"
  >
  </ui-button>
</app-shared-dialog>
